import { render, staticRenderFns } from "./clientFundDetail.vue?vue&type=template&id=1a18ce22&scoped=true"
import script from "./clientFundDetail.vue?vue&type=script&lang=js"
export * from "./clientFundDetail.vue?vue&type=script&lang=js"
import style0 from "./clientFundDetail.vue?vue&type=style&index=0&id=1a18ce22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a18ce22",
  null
  
)

export default component.exports